import { get } from "@sal/webrequest-web";
import { assertApiSuccess } from "code/apiError";
import { SelectOption } from "components/SelectInput";
import { Role } from "enums/Role";
import { useMemo } from "react";
import useSWR from "swr";

type CVRole = {
	value: Role;
	label: string;
};

const fetcher = async (url: string) => assertApiSuccess(await get(url), "Failed to load roles.");

const options = {
	revalidateIfStale: false,
	revalidateOnFocus: false,
	revalidateOnReconnect: false
};

export function useGetRoles(enabled = true) {
	const { data, isLoading, error } = useSWR(enabled ? "api/Roles/List" : null, fetcher, options);

	const roleOptions = useMemo(() => {
		const roles = Array.isArray(data) ? (data as CVRole[]) : [];

		return roles.map((role) => ({
			// Strip "CV - " prefix from DB labels (e.g. "CV - Administrator" → "Administrator")
			label: role.label.replace(/^CV\s*-\s*/i, ""),
			value: role.value
		})) as SelectOption[];
	}, [data]);

	return { roleOptions, isLoading, error };
}
